import React from "react"

import { ViewportCaps } from "./ViewportCaps"

export const defaultViewportCaps = new ViewportCaps(0, 0)

export const ViewportCapsContext = React.createContext<ViewportCaps>(defaultViewportCaps)

ViewportCapsContext.displayName = "ViewportCapsContext"
